<template>
  <div class="s-component img-bg" :style="{...defaultBg.style, backgroundImage: `url(${defaultBg.src}`}">
    <div :style="{...newLotteryTextStyle1, ...getPosition(lotteryText1Position)}">{{lotteryText1}}</div>
    <img :src="btnLottery.src" alt="" :style="{...btnLottery.style}" @click="lotteryFun()"/>
    <div :style="{...newLotteryTextStyle2, ...getPosition(lotteryText2Position)}">
      {{lotteryText2}}
      <span :style="newLotteryCountStyle">{{lotteryCount}}</span>
    </div>
    <div class="activity-list" id='activity-list'>
      <div v-for="(item,index) in activityListData" :key="index" class="activity-item">
        <img class="bottom-img" :src="item.img" alt=""/>
        <div class="time">{{item.time}}</div>
        <div class="textDesc">{{item.title}}</div>
        <img v-if="item.status === 0 || item.status === 1" :src="btnNowJump.src" alt="" :style="{...btnNowJump.style}" @click="jumpLink(item)"/>
        <img v-if="item.status === 3" :src="btnExpire.src" alt="" :style="{...btnExpire.style}"/>
        <img v-if="item.status === 2" :src="btnWaiting.src" alt="" :style="{...btnWaiting.style}"/>
      </div>
    </div>
  </div>
</template>

<script>
import { getPosition } from "@/components/BuilderComponents/utils";

export default {
  name: 'SWelfareCollectionActivity',
  components: {
  },
  props: {
    activityId: {
      type: String,
      default: ''
    },
    defaultBg: {
      type: Object,
      required: true
    },
    btnLottery: {
      type: Object,
      required: true
    },
    lotteryText1: {
      type: String,
      default: ''
    },
    lotteryText1Position: {
      type: String,
      default: ''
    },
    lotteryTextStyle1: {
      type: String,
      default: ''
    },
    lotteryText2: {
      type: String,
      default: ''
    },
    lotteryText2Position: {
      type: String,
      default: ''
    },
    lotteryTextStyle2: {
      type: String,
      default: ''
    },
    lotteryCountStyle: {
      type: String,
      default: ''
    },
    activityList: {
      type: Array,
      required: true
    },
    btnNowJump: {
      type: Object,
      required: true
    },
    btnExpire: {
      type: Object,
      required: true
    },
    btnWaiting: {
      type: Object,
      required: true
    },
    trackColor: {
      type: String,
      default: '#fff'
    },
    thumbColor: {
      type: String,
      required: '#fff'
    }
  },
  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    },
    newLotteryTextStyle1() {
      try {
        return JSON.parse(this.lotteryTextStyle1)
      } catch (e) {
        console.error('lotteryTextStyle1 格式错误')
        return {}
      }
    },
    newLotteryTextStyle2() {
      try {
        return JSON.parse(this.lotteryTextStyle2)
      } catch (e) {
        console.error('lotteryTextStyle2 格式错误')
        return {}
      }
    },
    newLotteryCountStyle() {
      try {
        return JSON.parse(this.lotteryCountStyle)
      } catch (e) {
        console.error('lotteryCountStyle 格式错误')
        return {}
      }
    }
  },
  watch: {
    'trackColor': {
      immediate: true,
      handler(newVal, oldVal) {
        if (oldVal && newVal !== oldVal) {
          this.updateStyle('--trackColor', newVal)
        }
      }
    },
    'thumbColor': {
      immediate: true,
      handler(newVal, oldVal) {
        if (oldVal && newVal !== oldVal) {
          this.updateStyle('--thumbColor', newVal)
        }
      }
    }
  },
  data() {
    return {
      lotteryCount: 0,
      activityListData: []
    }
  },
  inject: {
    eventBus: {
      default: null
    }
  },
  created() {
    this.activityListData = this.activityList;
  },
  mounted() {
    if (this.eventBus) {
      // 登录成功操作添加
      this.eventBus.on('loginSuccess', this.init)
      // 登出操作添加
      this.eventBus.on('signOut', this.signOut)
    }
    this.getLotteryTimes();
  },
  methods: {
    getPosition,
    // 登录成功操作，获取抽奖次数
    init() {
      this.getLotteryTimes();
    },
    // 登出操作
    signOut() {
      this.lotteryCount = 0
    },
    // 获取抽奖次数
    getLotteryTimes () {
      if (!window.$checkLogin()) return
      this.requestAPI({
        url: '/v1/three/banner',
        method: 'get',
        params: {
          a_id: this.activityId
        }
      }).then(data => {
        this.lotteryCount = data.times
        this.activityListData = this.activityListData.map((item, index) => Object.assign({}, item, data.list[index]));
      })
    },
    // 点击立即抽奖
    lotteryFun () {
      if (!window.$checkLogin()) return
      this.requestAPI({
        url: '/v1/uni/lottery',
        method: 'get',
        params: { a_id: this.activityId }
      }).then((res) => {
        // 抽奖成功之后抽奖次数更新
        this.getLotteryTimes();
        // 拉起抽奖成功弹窗
        // type: 1 游戏道具 2 实物奖励 3 虚拟积分
        if (res) {
          if (res.materials) {
            const materialsAll = [];
            res.materials.forEach((subitem) => {
              if (subitem.type !== 3) {
                materialsAll.push(subitem);
              }
            })
            this.openVersionDialogTipSuccess(materialsAll)
          } else {
            this.$alert(res.name || '谢谢参与');
          }
        } else {
          this.$message.error('抽奖失败')
        }
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 打开领取成功的弹窗
    openVersionDialogTipSuccess (materials) {
      if (materials.length <= 0) {
        return
      }
      let content = ''
      materials.forEach((item, index) => {
        if (index === materials.length - 1) {
          content = content + item.name + '*' + item.amount
        } else {
          content = content + item.name + '*' + item.amount + '+'
        }
      })
      this.$alert('恭喜您获得' + ' ' + content, '提示', { confirmButtonText: '确定' });
    },
    // 修改滚动条样式
    updateStyle(colorName, colorValue) {
      const root = document.getElementById('activity-list');
      // 设置CSS变量的值
      root.style.setProperty(colorName, colorValue);
    },
    // 立即前往
    jumpLink(item) {
      if (!window.$checkLogin()) return
      const search = window.location.search
      if (search && search.length > 0) {
        window.open(item.url + search, '_blank')
      } else {
        window.open(item.url, '_blank')
      }
      if (item.status === 0) {
        // 抽奖次数+1
        this.addLotteryCount(item);
      }
    },
    // 添加抽奖次数
    addLotteryCount(item) {
      this.requestAPI({
        url: '/v1/three/egg-times',
        method: 'get',
        params: { id: item.id, a_id: this.activityId }
      }).then(() => {
        // 抽奖次数更新
        this.getLotteryTimes();
      }).catch((err) => {
        this.$message.error(err.msg || '系统错误')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.img-bg {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  margin: 0 auto;
}
.s-component{
  --thumbColor: #792C81;
  --trackColor: #7d4f83;
  position: relative;
  .activity-list{
    position: absolute;
    left: 367px;
    top: 1258px;
    width: 1226px;
    height: 1062px;
    overflow-y: auto;
    &::-webkit-scrollbar{
      width: 5px;
    }
    /*滚动条里面小方块*/
    &::-webkit-scrollbar-thumb {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
      border-radius: 10px;
      background-color: var(--thumbColor);
    }
    /*滚动条里面轨道*/
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
      border-radius: 10px;
      background-color: var(--trackColor);
    }
    .activity-item{
      position: relative;
      width: 1188px;
      height: 353px;
      .bottom-img{
        width: 100%;
        height: 100%;
      }
      .time{
        position: absolute;
        left: 80px;
        top: 64px;
        font-size: 40px;
        color: #000000;
      }
      .textDesc{
        position: absolute;
        left: 91px;
        top: 176px;
        font-size: 58px;
        color: #000000;
      }
    }
  }
}
</style>
